<template>
    <div class="goods_detail">
        <van-pull-refresh v-model="pullloading" @refresh="onRefresh">
            <div class="banner" v-if="goods_pic2.length > 0">
                <div :class="{'swiper1': cats.length <= 1,'swiper2': cats.length > 1}">
                    <swiper :options="swiperOption2" @slideChange="onSlideChange2" ref="mySwiper2" v-if="showSwiper">
                        <div class="swiper-slide" :class="{'swiper-slide2': cats.length > 1, 'bg-white': item === slotImg}" v-for="(item,i) in goods_pic2" :key="i">
                            <img :data-src="item" class="swiper-lazy"/>
                            <div class="swiper-lazy-preloader"></div>
                        </div>
                    </swiper>
                </div>
                

                <div class="current">{{ current2 }} / {{ goods_pic2.length }}</div>
                <div class="swiper-button-prev swiper-button-prev2" :class="{'prev': cats.length > 1}" v-if="goods_pic2.length > 1">
                    <van-icon name="arrow-left" />
                </div>
                <div class="swiper-button-next swiper-button-next2" :class="{'next': cats.length > 1}" v-if="goods_pic2.length > 1">
                    <van-icon name="arrow" />
                </div>

                <div class="cats" v-if="cats.length > 1">
                    <swiper :options="swiperOptionCats" ref="mySwiperCats">
                        <swiper-slide v-for="(item,i) in cats" :key="i">
                            <p :class="{'active': cat_active == item.id}" @click="getCatsImg(item.id)">{{ item.name }}</p>
                        </swiper-slide>
                    </swiper>
                </div>
            </div>
            <div class="info_box">
                <div class="info">
                    <van-image class="icon" :src="game_icon" />
                    <div class="right">
                        <p class="p0" v-if="goods">{{ goods.goods_name }}</p>
                        <p class="p1" v-if="goods">
                            <i>{{ goods.server_name }}</i>
                            <i>{{ goods.role_name }}</i>
                        </p>
                        <p class="p2" v-if="goods_pic2.length == 0">
                            <span v-if="goods">{{ goods.role_name }}</span>
                            <img class="sex" src="../../assets/bx/acc/nan.png" alt=""
                                v-if="goods_role_info&&goods_role_info.sex == 1">
                            <img class="sex" src="../../assets/bx/acc/nv.png" alt=""
                                v-else-if="goods_role_info&&goods_role_info.sex == 2">
                            <span class="lv" v-if="goods_role_info&&goods_role_info.lv">{{ goods_role_info.lv }}级</span>
                        </p>
                        <div class="p3" v-if="goods_pic2.length == 0">
                            <div class="left">
                                <span class="career"
                                    v-if="goods_role_info&&goods_role_info.career!=''">{{ goods_role_info.career }}</span>
                                <span class="power"
                                    v-if="goods_role_info&&goods_role_info.power">战力&nbsp;{{ goods_role_info.power }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="role-info" v-if="roleAttrConf.length > 0">
                    <p class="ri-item" v-for="(item,i) in roleAttrConf" :key="i">
                        <span>{{ item.name }}</span>
                        <span>{{ item.val }}</span>
                    </p>
                </div>

                <div class="down_collect" v-if="goods">
                    <p>{{ left_time }} <span v-if="left_time != '商品已过期，即将自动下架'">后下架</span></p>
                    <p class="price"><i>&yen;&nbsp;</i>{{ goods.price }}</p>
                </div>
            </div>
            <div class="tips">平台保障，安心无忧</div>
            <div class="notice" v-if="notice">
                <span class="tit">交易须知：</span>
                <span v-html="notice"></span>
            </div>
            <div class="desc" v-if="goods_role_info && goods_role_info.desc != ''">
                <div class="tit">卖家描述</div>
                <div class="cont">{{goods_role_info.desc}}</div>
            </div>
        </van-pull-refresh>

        <div class="btns">
            <!-- <div class="left">
                <p :class="{'collect':is_collect == 1}" @click="collect"><van-icon name="star"/>{{ is_collect == 1 ? '已收藏' : '收藏' }}</p>
            </div> -->
            <van-button class="buy" :disabled="disabled" round :loading="loading" @click="buy">前往购买</van-button>
        </div>
    </div>
</template>

<script>
    let vm = null
    import "swiper/dist/css/swiper.css";
    import {
        swiper,
        swiperSlide
    } from "vue-awesome-swiper";
    import {
        ImagePreview
    } from 'vant';
    export default {
        components: {
            swiper,
            swiperSlide,
        },
        data() {
            return {
                slotImg: require('../../assets/bx/slot.png'),
                pullloading: false,
                current: 1,
                current2: 1,

                goods: null,
                account: '',
                app_name: '',
                goods_role_info: null,
                goods_pic: [],
                goods_pic2: [],
                loading: false,
                is_collect: 0,
                left_time: '',
                swiperOption2: {
                    initialSlide: 0,
                    loop: true,
                    speed: 300,
                    observer: true,
                    observeParents: true,
                    touchMoveStopPropagation: true,
                    longSwipesRatio: 0.1,
                    threshold: 5,
                    lazy: {
                      loadPrevNext: true,
                    },
                    autoplay: {
                        delay: 4000,
                        stopOnLastSlide: false,
                        disableOnInteraction: false,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next2',
                        prevEl: '.swiper-button-prev2',
                    },
                    on: {
                        click: function (e) {
                            if (e.target.className.indexOf('swiper-pagination') > -1) return;
                            vm.previewImg2()
                        }
                    }
                },
                notice: '',
                game_icon: '',
                disabled: true,
                role_info: [], //角色信息
                cats: [],
                cat_active: null,
                app_id: '',
                swiperOptionCats: {
                    slidesPerView: 6,
                    freeMode: true,
                    // grabCursor: true,
                    mousewheel: true,
                    allowTouchMove: true
                },
                showSwiper: true,
                roleAttrConf: []
            }
        },
        computed: {
            goods_id() {
                return this.$route.query.goods_id
            },
            isLogin() {
                return this.$store.getters.isLogin;
            },
        },
        created() {
            vm = this
        },
        mounted() {
            this.getDetail(this.goods_id)
        },
        methods: {
            previewImg() {
                var that = this
                var list = this.goods_pic.map(item => {
                    return item.pic_url;
                })
                ImagePreview({
                    images: list,
                    startPosition: that.current - 1
                })
            },
            previewImg2() {
                var that = this
                var list = this.goods_pic2.map(item => {
                    return item;
                })
                if (this.$refs.mySwiper2 && this.$refs.mySwiper2.swiper) {
                    this.$refs.mySwiper2.swiper.autoplay.stop();
                }
                ImagePreview({
                    images: list,
                    startPosition: that.current2 - 1,
                    onClose: () => {
                        if (that.goods_pic2.length > 1 && that.$refs.mySwiper2 && that.$refs.mySwiper2.swiper) {
                            that.$refs.mySwiper2.swiper.autoplay.start();
                        }
                    }
                })
            },
            onSlideChange() {
                this.current = this.$refs.mySwiper.swiper.realIndex + 1
            },
            onSlideChange2() {
                this.current2 = this.$refs.mySwiper2.swiper.realIndex + 1
            },
            onRefresh() {
                var that = this;
                setTimeout(() => {
                    that.getDetail(that.goods_id)
                    that.pullloading = false;
                }, 1000);
            },
            distanceOpenTime(showTime) {
                if (!showTime) return ''
                let timer = showTime
                const currentTime = new Date()
                const targetTime = new Date(String(showTime).replace(/\-/g, "/"))
                // 计算时间差（以毫秒为单位）
                const timeDiff = targetTime.getTime() - currentTime.getTime()
                // 将时间差转换为小时、分钟和秒数
                const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24))
                const hours = Math.floor(timeDiff / (1000 * 60 * 60) % 24)
                const minutes = Math.floor((timeDiff / (1000 * 60)) % 60)
                const seconds = Math.floor((timeDiff / 1000) % 60)
                let ret = days >= 0 ? `${days}天${hours}小时` : '商品已过期，即将自动下架'
                return ret
            },
            getCatsImg(cat_id) {
                // var list = [
                //     ['https://tradingimage.3975.com/game_market/Uploads/Picture/2025-12-23/176645642932145.jpg','https://tradingimage.3975.com/game-market/Uploads/Picture/168388194410156.png'],
                //     ['https://tradingimage.3975.com/game-market/Uploads/Picture/168388194410156.png'],
                //     ['https://tradingimage.3975.com/game-market/Uploads/Picture/168603091054188.png','https://tradingimage.3975.com/game-market/Uploads/Picture/168766132466047.png','https://tradingimage.3975.com/game-market/Uploads/Picture/168800325076578.png'],
                //     ['https://tradingimage.3975.com/game-market/Uploads/Picture/168905843842848.png','https://tradingimage.3975.com/game-market/Uploads/Picture/168905847477638.png'],
                //     ['https://tradingimage.3975.com/game_market/Uploads/Picture/171029263718291.png'],
                //     ['http://tradingimage.3975.com/39jiaoyi/Uploads/Picture/170926417933285.jpg','https://tradingimage.3975.com/game-market/Uploads/Picture/168956330313507.png','https://tradingimage.3975.com/game_market/Uploads/Picture/172060394210313.png','http://tradingimage.3975.com/39jiaoyi/Uploads/Picture/169942692481921.png'],
                //     ['http://tradingimage.3975.com/39jiaoyi/Uploads/Picture/170001518327642.png'],
                //     ['https://tradingimage.3975.com/game_market/game/icon/175125298686021.png']
                // ]
                // this.cat_active = cat_id
                // this.showSwiper = false
                // this.$nextTick(() => {
                //     this.goods_pic2 = list[cat_id]
                //     this.swiperOption2.loop = this.goods_pic2.length > 1
                //     this.current2 = 1
                //     this.showSwiper = true
                //     this.$nextTick(() => {
                //         if (this.$refs.mySwiperCats && this.$refs.mySwiperCats.swiper) {
                //             const index = this.cats.findIndex(item => item.id == cat_id)
                //             if (index > -1) {
                //                 this.$refs.mySwiperCats.swiper.slideTo(index - 2, 300, false)
                //             }
                //         }
                //     })
                // })
                // return
                this.cat_active = cat_id
                this.showSwiper = false
                this.$Ajax('goods-role/images-by-cat', {
                    app_id: this.app_id,
                    goods_id: this.goods_id,
                    cat_id
                }, 'post').then(rs => {
                    if (rs.code == 200) {
                        this.goods_pic2 = rs.data
                        if(this.goods_pic2.length == 0) {
                            this.goods_pic2 = [this.slotImg]
                        }
                        this.swiperOption2.loop = this.goods_pic2.length > 1
                        this.current2 = 1
                        this.showSwiper = true
                        this.$nextTick(() => {
                            if (this.$refs.mySwiperCats && this.$refs.mySwiperCats.swiper) {
                                const index = this.cats.findIndex(item => item.id == cat_id)
                                if (index > -1) {
                                    this.$refs.mySwiperCats.swiper.slideTo(index - 2, 300, false)
                                }
                            }
                        })
                    }
                })
            },
            getDetail(goods_id) {
                this.$Ajax('goods-role/detail', {
                    goods_id
                }, 'post').then(rs => {
                    if (rs.code == 200) {
                        this.game_icon = rs.data.icon
                        this.goods = rs.data.goods
                        this.account = rs.data.account
                        this.app_name = rs.data.app_name
                        this.goods_role_info = rs.data.goods_role_info
                        
                        if(rs.data.roleAttrConf) {
                            if(Array.isArray(rs.data.roleAttrConf)) {
                                this.roleAttrConf = rs.data.roleAttrConf
                            }else {
                                this.roleAttrConf = Object.values(rs.data.roleAttrConf)
                            }
                        }
                        this.app_id = rs.data.goods.app_id
                        this.cats = rs.data.cats
                        // this.cats = [
                        //     {id: 0, name: "默认"},
                        //     {id: 1, name: "装备"},
                        //     {id: 2, name: "等级"},
                        //     {id: 3, name: "金币"},
                        //     {id: 4, name: "宠物"},
                        //     {id: 5, name: "道具"},
                        //     {id: 6, name: "道具2"},
                        // ]
                        this.swiperOptionCats.slidesPerView = this.cats.length > 6 ? 6 : this.cats.length
                        this.swiperOptionCats.allowTouchMove = this.cats.length > 6
                        if(rs.data.cats.length > 0) {
                            this.cat_active = this.cats[0].id
                            this.getCatsImg(rs.data.cats[0].id)
                        }
                        if(this.goods_pic2.length == 1) {
                            this.swiperOption2.loop = false
                        }
                        this.left_time = this.distanceOpenTime(rs.data.goods.exprice_time)
                        if(this.left_time != '商品已过期，即将自动下架') {
                            this.disabled = false
                        }else {
                            this.disabled = true
                        }
                        if(rs.data.goods.app_id) {
                            this.$Ajax('game/app-list').then(res => {
                                if (res.code == 200) {
                                    var item = res.data.find(item => item.id == rs.data.goods.app_id)
                                    this.notice = item.notice
                                }
                            })
                        }
                    }else {
                        this.disabled = true
                    }
                })
            },
            //收藏
            collect() {
                var api = this.is_collect == 0 ? 'acc/goods/add-favorite' : 'acc/goods/remove-favorite'
                if (this.isLogin) {
                    this.$Ajax(api, {
                        goods_id: this.goods_id
                    }, 'post').then(rs => {
                        if (rs.code == 200) {
                            if (this.is_collect == 0) this.is_collect = 1
                            else if (this.is_collect == 1) this.is_collect = 0
                        }
                    })
                } else {
                    this.$filterPop({
                        type: 'login',
                        direction: 'up',
                        onSuccess: () => {
                            setTimeout(() => {
                                this.$Ajax(api, {
                                    goods_id: this.goods_id
                                }, 'post').then(rs => {
                                    if (rs.code == 200) {
                                        if (this.is_collect == 0) this.is_collect = 1
                                        else if (this.is_collect == 1) this.is_collect = 0
                                    }
                                })
                            }, 500)
                        }
                    })
                }
            },
            buy() {
                this.loading = true
                if (this.isLogin) {

                    this.$router.push({
                        name: 'acc.buy',
                        query: {
                            goods_id: this.goods_id
                        }
                    })
                    setTimeout(() => {
                        this.loading = false
                    }, 2000)
                } else {
                    this.$filterPop({
                        type: 'login',
                        direction: 'up',
                        onSuccess: () => {
                            this.$router.push({
                                name: 'acc.buy',
                                query: {
                                    goods_id: this.goods_id
                                }
                            })
                        }
                    })
                    setTimeout(() => {
                        this.loading = false
                    }, 2000)
                }
            }
        },
        watch: {

        },
    }
</script>

<style lang="less" scoped>
    .goods_detail {
        padding: 0 0 8rem;
    }

    .banner {
        min-height: 19.7rem;
        z-index: 1;
        position: relative;
        .swiper1 {
            height: 19.7rem;
        }
        .swiper2 {
            height: 25rem;
        }
        .swiper-slide {
            height: 19.7rem;
            background-color: #000;
            &.bg-white {
                background-color: #fff;
            }
            &.swiper-slide2 {
                height: 25rem;
                padding-bottom: 5.3rem;
            }
        }

        img {
            height: 100%;
            max-width: 100%;
            display: block;
            margin: 0 auto;
            object-fit: cover;
        }

        .swiper-button-prev,
        .swiper-button-next {
            &.prev {
                top: 40%;
            }
            &.next {
                top: 40%;
            }
            background-image: unset;
            width: 3rem;
            height: 3rem;

            .van-icon {
                font-size: 3rem;
                color: #3d3d3d;
            }
        }

        .current {
            position: absolute;
            right: 1rem;
            top: 1rem;
            z-index: 10;
            padding: 0 1.2rem;
            height: 1.8rem;
            line-height: 1.8rem;
            background-color: #3d3d3d;
            color: #fff;
            border-radius: 10rem;
        }

        /deep/ .swiper-pagination {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 5.3rem;
            display: flex;
            justify-content: center;
            z-index: 10;
            
            .swiper-pagination-bullet {
                margin: 0;
                flex: 1;
                height: 100%;
                line-height: 4.2rem;
                border-radius: 0;
                background-color: #FFEFE4;
                font-size: 1.6rem;
                color: #000;
                opacity: 1;
                border: none;
                outline: none;
                &.swiper-pagination-bullet-active {
                    background: #F66F30;
                    color: #fff;
                }
            }
        }
        .cats {
            position: absolute;
            z-index: 2;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 5.3rem;
            line-height: 4.2rem;
            font-size: 1.6rem;
            color: #000;
            text-align: center;
            background-color: #FFEFE4;
            /deep/ .swiper-container {
                height: 100%;
                .swiper-slide {
                    height: 100%;
                }
            }

            p {
                width: 100%;
                height: 100%;
                background-color: #FFEFE4;
                cursor: pointer;
                &.active {
                    background-color: #F66F30;
                    color: #fff;
                }
            }
        }
    }
    .jiange {
        height: 1rem;
    }
    .info_box {
        position: relative;
        z-index: 2;
        margin: 0;
        border-radius: 1rem;
        padding: 1.9rem 1rem 0;
        background-color: #fff;
        border-top-left-radius: 1rem;
        border-top-right-radius: 1rem;
        margin-top: -1rem;
        .tit {
            font-size: 1.6rem;
            color: #000;
            word-break: break-all;
            margin-bottom: .8rem;
        }

        .info {
            display: flex;
            margin-bottom: 1.4rem;

            .icon {
                width: 6rem;
                height: 6rem;
                border-radius: 1rem;
                overflow: hidden;
                margin-right: .9rem;
            }

            .right {
                flex: 1;
                overflow: hidden;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .p0 {
                    color: #000;
                    font-size: 1.6rem;
                    max-height: 4rem;
                    word-break: break-all;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
                .p1 {
                    margin-top: .4rem;
                    font-size: 1.3rem;
                    color: #999;

                    i {
                        border-left: 1px solid #999;
                        margin-left: 0.6rem;
                        padding-left: 0.6rem;
                        &:first-child {
                            margin-left: 0;
                            padding-left: 0;
                            border: none;
                        }
                    }
                }

                .p2 {
                    font-size: 1.3rem;
                    columns: #999;
                    display: flex;
                    align-items: center;
                    margin: .2rem 0;

                    .sex {
                        width: 1.6rem;
                        height: 1.6rem;
                    }

                    span {
                        color: #000;
                    }

                    .lv {
                        color: #999;
                        border-left: 1px solid #999;
                        margin-left: 0.4rem;
                        padding-left: 0.6rem;
                    }
                }

                .p3 {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    font-size: 1.3rem;
                    color: #999;

                    .left {
                        .career {
                            color: #000;
                            padding-right: 1rem;
                        }

                        .power {
                            border-left: 1px solid #999;
                            padding-left: 0.6rem;
                        }
                    }
                }
            }
        }
        .role-info {
            background-color: rgba(255, 240, 233, .46);
            border-radius: 1rem;
            padding: 1.7rem 1rem;
            display: flex;
            flex-wrap: wrap;
            position: relative;
            &::after {
                content: '';
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                width: 1px;
                height: calc(100% - 3.4rem);
                background-color: rgba(146, 146, 146, .3);
            }
            .ri-item {
                width: 50%;
                font-size: 1.3rem;
                color: #000;
                margin-top: 1.4rem;
                display: flex;
                justify-content: space-between;
                &:nth-of-type(1),
                &:nth-of-type(2) {
                    margin-top: 0;
                }
                &:nth-of-type(2n) {
                    padding-left: 2rem;
                }
                &:nth-of-type(2n+1) {
                    padding-right: 2rem;
                }
            }
        }
        .down_collect {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 1.3rem;
            color: #999;
            padding: 0 1rem;
            margin: 1.5rem 0 1.4rem;
            .price {
                font-size: 1.6rem;
                color: var(--theme);
                font-weight: 700;
                i {
                    font-size: 1.2rem;
                    font-weight: 400;
                }
            }
        }
    }

    .tips {
        margin: 0 1rem;
        background-color: var(--themebgc);
        color: var(--theme);
        height: 2.6rem;
        line-height: 2.6rem;
        text-align: center;
        border-radius: 0.3rem;
    }
    .notice {
        padding: 1.2rem 1rem 0;
        background-color: #fff;
        border-radius: 1rem;
        span {
            color: #555;
            font-size: 1.4rem;
            word-break: break-all;
        }
        .tit {
            font-weight: 700;
            font-size: 1.4rem;
            color: #000;
        }
    }
    .desc {
        padding: 2rem 1rem;
        background-color: #fff;
        border-radius: 1rem;

        .tit {
            font-size: 1.4rem;
            color: #555;
            font-weight: 700;
            margin-bottom: 1rem;
        }

        .cont {
            font-size: 1.4rem;
            color: #555;
            line-height: 1.5;
            text-indent: 2.8rem;
            word-break: break-all;
        }
    }

    .btns {
        height: 7rem;
        width: 100%;
        max-width: 525px;
        position: fixed;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        justify-content: space-between;
        background-color: #fff;
        padding: 0 2rem;
        z-index: 10;
        .left {
            p {
                margin-top: 1rem;
                margin-right: 2rem;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                font-size: 1.2rem;
                color: #555;
                width: 3.6rem;
                cursor: pointer;

                .van-icon {
                    font-size: 2.2rem;
                    color: #e3e3e3;
                }

                &.collect {
                    color: var(--theme);

                    .van-icon {
                        color: var(--theme);
                    }
                }
            }
        }

        .buy {
            width: 100%;
            margin-top: 1.2rem;
            height: 3.4rem;
            background-color: var(--theme);
            color: #fff;
            font-size: 1.4rem;
        }
    }
</style>
